import { PolicyDocument } from '../services/policy-gap-analysis.service';

export const documentsMockData: PolicyDocument[] = [
  {
    id: 1,
    file_name: 'Information Security Policy v3.2.pdf',
    file_type: 'pdf',
    uploaded_at: '2025-12-10T14:30:00Z',
    uploaded_by: 'jsmith@acmecorp.com',
    status: 'analyzed',
    domains: [
      'access_control',
      'endpoint_security',
      'identity_authentication',
      'incident_response',
      'logging_monitoring',
      'vulnerability_management',
      'security_awareness',
      'backup_recovery',
    ],
    statement_count: 28,
    report_card: {
      alignment_label: 'moderate',
      validated_count: 10,
      documented_not_validated_count: 7,
      recommended_not_documented_count: 5,
      not_verifiable_count: 3,
      potentially_verifiable_count: 3,
      total_findings: 28,
    },
  },
  {
    id: 2,
    file_name: 'Access Control Procedures.docx',
    file_type: 'docx',
    uploaded_at: '2025-12-12T09:15:00Z',
    uploaded_by: 'jsmith@acmecorp.com',
    status: 'analyzed',
    domains: ['access_control', 'identity_authentication'],
    statement_count: 12,
    report_card: {
      alignment_label: 'strong',
      validated_count: 7,
      documented_not_validated_count: 2,
      recommended_not_documented_count: 1,
      not_verifiable_count: 1,
      potentially_verifiable_count: 1,
      total_findings: 12,
    },
  },
  {
    id: 3,
    file_name: 'Incident Response Plan 2024.pdf',
    file_type: 'pdf',
    uploaded_at: '2025-12-15T11:00:00Z',
    uploaded_by: 'klee@acmecorp.com',
    status: 'analyzed',
    domains: ['incident_response', 'logging_monitoring'],
    statement_count: 10,
    report_card: {
      alignment_label: 'limited',
      validated_count: 2,
      documented_not_validated_count: 4,
      recommended_not_documented_count: 2,
      not_verifiable_count: 1,
      potentially_verifiable_count: 1,
      total_findings: 10,
    },
  },
  {
    id: 4,
    file_name: 'Vulnerability Management Standard.docx',
    file_type: 'docx',
    uploaded_at: '2025-12-18T16:45:00Z',
    uploaded_by: 'jsmith@acmecorp.com',
    status: 'analyzed',
    domains: ['vulnerability_management', 'endpoint_security'],
    statement_count: 14,
    report_card: {
      alignment_label: 'moderate',
      validated_count: 5,
      documented_not_validated_count: 4,
      recommended_not_documented_count: 3,
      not_verifiable_count: 1,
      potentially_verifiable_count: 1,
      total_findings: 14,
    },
  },
  {
    id: 5,
    file_name: 'Backup and Recovery Procedures.pdf',
    file_type: 'pdf',
    uploaded_at: '2025-12-20T08:30:00Z',
    uploaded_by: 'klee@acmecorp.com',
    status: 'processing',
    domains: [],
    statement_count: 0,
    report_card: null,
  },
  {
    id: 6,
    file_name: 'Network Security Architecture.docx',
    file_type: 'docx',
    uploaded_at: '2025-12-20T08:35:00Z',
    uploaded_by: 'jsmith@acmecorp.com',
    status: 'error',
    domains: [],
    statement_count: 0,
    report_card: null,
  },
];
